(function () {

    "use strict";

    angular
        .module("harriApp")
        .component("videoReviewerComponent", {
            controller: VideoReviewerComponent,
            bindings: {
                card: '<',
                hMapMode: '<',
                defaultLocation: '<',
                reviewers: '<',
                canReview: '<',
            },
            controllerAs: '$ctrl',
            templateUrl: '../modules/speedy_screen/components/video-reviewer/video-reviewer.component.html'
        });

    VideoReviewerComponent.$inject = ['$scope', '$state', 'hUser', 'hFormsService', 'amsBus', 'interviewBankDataService'];

    function VideoReviewerComponent($scope, $state, hUser, hFormsService, amsBus, interviewBankDataService) {

        var self = this;
        self.data = {};
        self.data.questions = [];
        self.data.interviewStatus = '';
        self.STATUSES = QuestionBankAPI.STATUSES;
        self.reviewedAnswers = {};
        self.showReviews = [];
        self.data.evaluations = {};
        self.reviewers = [];

        var _AMSDataManager,
            _AMSActions,
            _AMSRenderHelper;

        if (amsBus.isAMSInitialized) {
            _AMSDataManager = amsBus._AMSDataManager;
            _AMSActions = amsBus._AMSActions;
            _AMSRenderHelper = amsBus._AMSRenderHelper;
            self.job = _AMSDataManager.job;
        }

        var goNext = function() {
            setTimeout(function(){
                $(".speedyx-arrow.go-right").click();
            }, 1);
        };

        var prepareState = function(candidate, location, toBucket) {
            var appInformation = _AMSDataManager.getCardsFromAppIds([candidate.id]);

            var appIdsGroup = [ [{'app_id':candidate.id, 'index':appInformation[candidate.id].index}] ];

            var fromState = {
                indices: [appInformation[candidate.id].index],
                bucket: appInformation[candidate.id].bucket,
                location: appInformation[candidate.id].location
            };

            var toState = {
                indices: [0],
                bucket: toBucket,
                location: location
            };

            return {
                appIds: appIdsGroup,
                fromState: [fromState],
                toState: toState
            }
        };

        self.passCandidate = function(candidate, location) {
            if (!self.skipDisabled && !self.buttonsDisabled) {

                var appInformation = _AMSDataManager.getCardsFromAppIds([candidate.id]);
                var appIdsGroup = [[{'app_id': candidate.id, 'index': appInformation[candidate.id].index}]];

                var fromState = [{
                    indices: [appInformation[candidate.id].index],
                    bucket: appInformation[candidate.id].bucket,
                    location: appInformation[candidate.id].location
                }];

                var to_location = appInformation[candidate.id].location;

                if (to_location == 'all') {
                    to_location = _AMSDataManager.getBucketFirstLocationId(AMSAPI.PASSED);
                }

                var toState = {
                    indices: [0],
                    bucket: AMSAPI.PASSED,
                    location: to_location
                };

                self.skipDisabled = true;
                self.buttonsDisabled = true;

                _AMSActions.handleAction(appIdsGroup, fromState, toState)
                    .then(function () {
                        self.card.bucket_id = toState.bucket;
                        // Cancel the interview from card in case of interview already scheduled
                        self.card.schedule_date = [];
                        goNext();
                    })
                    .finally(function () {
                        self.skipDisabled = false;
                        self.buttonsDisabled = false;
                    });
            }
        };

        self.getNextBucket = function (bucketId) {
            if (_AMSRenderHelper) {
                return _AMSRenderHelper.getNextBucket(bucketId);
            }
        };

        self.isCustom = function (bucketId) {
            if (_AMSDataManager) {
                return _AMSDataManager.data[bucketId].type === 'CUSTOM';
            }
        };

        self.getBucketWeight = function (bucketId) {
            if (_AMSDataManager && _AMSDataManager.data && _AMSDataManager.data[bucketId]) {
                return _AMSDataManager.data[bucketId].weight;
            }
            return false;
        };

        self.isBeforeOffer = function () {
            if (_AMSDataManager && _AMSDataManager.data) {
                var tempBucket = 0;
                if (_AMSDataManager.data[AMSAPI.OFFER]) {
                    tempBucket = AMSAPI.OFFER;
                } else if (_AMSDataManager.data[AMSAPI.ONBOARDING]) {
                    tempBucket = AMSAPI.ONBOARDING;
                } else if (_AMSDataManager.data[AMSAPI.HIRED]) {
                    tempBucket = AMSAPI.HIRED;
                }
                return self.getBucketWeight(self.card.bucket_id) < self.getBucketWeight(tempBucket);
            }
            return false;
        };

        self.isInSpecificColumn = function (bucketsIdsToCheck) {
            if (_AMSDataManager && _AMSDataManager.data) {
                for (var i in bucketsIdsToCheck) {
                    var bucketId = bucketsIdsToCheck[i];
                    if (self.getBucketWeight(bucketId) &&
                        self.getBucketWeight(self.card.bucket_id) === self.getBucketWeight(bucketId)) {
                        return true;
                    }
                }
            }
            return false;
        };

        self.showSkipButton = function () {
            return !self.isInSpecificColumn([self.card.AMSAPI.PASSED]) &&
                (
                    self.getBucketWeight(self.card.bucket_id) < 5000 ||
                    self.isInSpecificColumn([self.card.AMSAPI.RIGHT_TO_WORK, self.card.AMSAPI.KEESING])
                );
        };

        self.showMoveNextButton = function () {
            return !self.isInSpecificColumn([self.card.AMSAPI.PASSED]) &&
                (self.isBeforeOffer(self.getNextBucket(self.card.bucket_id)) || !self.hMapMode);
        };

        self.restoreCandidate = function(candidate, location) {
            if (!self.restoreDisabled && !self.buttonsDisabled) {
                var toLocation = location || AMSAPI.GENERIC_LOCATION;

                var state = prepareState(candidate, toLocation, AMSAPI.APPLICANTS);

                self.card.bucket_id = state.toState.bucket;

                self.restoreDisabled = true;
                self.buttonsDisabled = true;

                _AMSActions.handleAction(state.appIds, state.fromState, state.toState)
                    .then(function () {
                        self.card.bucket_id = state.toState.bucket;
                        goNext();
                    })
                    .finally(function () {
                        self.restoreDisabled = false;
                        self.buttonsDisabled = false;
                    });
            }
        };

        self.messageCandidate = function(candidate, location, toBucketId) {
            if (!self.moveNextDisabled && !self.buttonsDisabled) {
                var toLocation = location || AMSAPI.GENERIC_LOCATION;

                var state = prepareState(candidate, toLocation, String(toBucketId));

                self.card.bucket_id = state.toState.bucket;

                self.moveNextDisabled = true;
                self.buttonsDisabled = true;

                _AMSActions.handleAction(state.appIds, state.fromState, state.toState)
                    .then(function () {
                        self.card.bucket_id = state.toState.bucket;
                        goNext();
                    })
                    .finally(function () {
                        self.moveNextDisabled = false;
                        self.buttonsDisabled = false;
                    });
            }
        };

        var videoReviewerForm = hFormsService.getForm("videoReviewerForm");

        var remakeEvaluationsStructure = function () {
            for (var i in self.data.reviews) {
                var review = self.data.reviews[i];
                for (var j in review.answers_evaluations) {
                    var evaluation = review.answers_evaluations[j];
                    if (evaluation && evaluation.answer_id) {
                        self.data.evaluations[evaluation.answer_id] = self.data.evaluations[evaluation.answer_id] || [];
                        self.data.evaluations[evaluation.answer_id].push({
                            review: evaluation,
                            reviewer: review.interviewer_user
                        });
                        if (review.interviewer_user.id === hUser.data.user.id) {
                            var index = _.findIndex(self.data.questions, function (question) {
                                return question.answer.id === evaluation.answer_id;
                            });
                            self.reviewedAnswers[index] = 'success';
                        }
                    }
                }
            }
        };

        interviewBankDataService.on('reviewedSuccessfully', function (res, index, answerId, payload) {
            if (res) {
                if (res.interview) {
                    self.data.totalScore = res.interview.total_score;
                }

                if (res.evaluation && !isNaN(parseFloat(res.evaluation.total_score)) && res.interview && !isNaN(parseFloat(res.interview.total_score))) {
                    var reviewer = _.find(self.reviewers, function (item) {
                        return item.interviewer_user.id === hUser.data.user.id;
                    });

                    reviewer.total_score = res.evaluation.total_score;

                    if (self.reviewer && !isNaN(parseFloat(self.reviewer.total_score))) {
                        self.reviewer.total_score = res.evaluation.total_score;
                    }
                    self.card.video_interview.status = self.STATUSES.INTERVIEWED;
                    self.card.video_interview.reviewer = "CAN_NOT_REVIEW";
                    self.card.video_interview.total_score = res.interview.total_score;

                    var card = {};
                    card.application_id = self.card.application_id;
                    card.video_interview = self.card.video_interview;
                    card = _AMSDataManager.updateCard(card);
                    _AMSRenderHelper.invalidateCard(card);
                }
            }
            self.data.evaluations[answerId] = self.data.evaluations[answerId] || [];
            self.data.evaluations[answerId].push({
                review: payload,
                reviewer: {
                    id: hUser.data.user.id,
                    first_name: hUser.data.user.first_name,
                    last_name: hUser.data.user.last_name,
                }
            });
            self.reviewedAnswers[index] = 'success';
            var tempIndex = index + 1;
            if (tempIndex < self.data.questions.length) {
                self.onSelectQuestion(tempIndex);
            }
        });

        interviewBankDataService.on('overAllReviewedSuccessfully', function (res) {
            if (res) {
                if (res.interview) {
                    self.data.totalScore = res.interview.total_score;
                }

                if (res.evaluation && !isNaN(parseFloat(res.evaluation.total_score)) && res.interview && !isNaN(parseFloat(res.interview.total_score))) {
                    var reviewer = _.find(self.reviewers, function (item) {
                        return item.interviewer_user.id === hUser.data.user.id;
                    });
                    reviewer.total_score = res.evaluation.total_score;

                    if (self.reviewer) {
                        self.reviewer.total_score = res.evaluation.total_score;
                    }

                    self.card.video_interview.status = self.STATUSES.INTERVIEWED;
                    self.card.video_interview.reviewer = "CAN_NOT_REVIEW";
                    self.card.video_interview.total_score = res.interview.total_score;

                    var card = {};
                    card.application_id = self.card.application_id;
                    card.video_interview = self.card.video_interview;
                    card = _AMSDataManager.updateCard(card);
                    _AMSRenderHelper.invalidateCard(card);
                    _AMSRenderHelper.renderCards();
                }
            }
        });

        interviewBankDataService.on('failedToReview', function (index) {
            self.reviewedAnswers[index] = 'failure';
        });

        self.$onInit = function () {
            self.videoReviewerForm = new videoReviewerForm($scope, "video-reviewer-form");
            self.reviewer = _.find(self.reviewers, function (item) {
                return item.interviewer_user.id === hUser.data.user.id;
            });
            self.loading = true;
            interviewBankDataService.getApplicantInterview(self.card.brand_id, interviewBankDataService.SERVICE_TYPES.VIDEO_INTERVIEW, self.card.application_id)
                .then(function (res) {
                    self.loading = false;
                    if (res && !_.isEmpty(res)) {
                        var data = angular.copy(res);
                        self.data.questions = data.questions;
                        self.data.totalScore = null;
                        self.data.interviewStatus = data.status;
                        self.data.interviewId = data.id;
                        self.data.reviews = data.evaluations;
                        self.data.totalScore = data.total_score;
                        remakeEvaluationsStructure();
                        if (data.template) {
                            self.data.scoringMode = data.template.scoring_mode;
                        }
                        var tempData = {
                            brandId: self.card.brand_id,
                            applicantId: self.card.application_id,
                            questions: data.questions,
                            interviewId: data.id
                        };
                        self.videoReviewerForm.load(tempData);
                        self.onSelectQuestion(0);
                    }
                })
                .catch(function (err) {
                    self.loading = false;
                    console.error(err);
                });
        };

        self.addReview = function () {
            if (self.data.tempTotalScore > 0) {
                var param = {
                    total_score: self.data.tempTotalScore,
                };

                self.evaluating = true;
                interviewBankDataService.postOverAllScore(self.card.brand_id, interviewBankDataService.SERVICE_TYPES.VIDEO_INTERVIEW, self.card.application_id, self.data.interviewId, param)
                    .then(function (res) {
                        if (res && res.interview) {
                            self.data.totalScore = res.interview.total_score;
                        }
                    })
                    .catch(function (err) {
                        self.data.tempTotalScore = 0;
                        hAlert($filter('translate')('Video screening'), $filter('translate')('Error while submitting review'));
                        console.error(err);
                    })
                    .finally(function () {
                        self.evaluating = false;
                    });
            }
        };

        self.onSelectQuestion = function (index) {
            self.showReviews[self.selectedQuetionIndex] = false;
            if (self.selectedQuetionIndex === index) {
                delete self.selectedQuetionIndex;
            } else {
                self.selectedQuetionIndex = index;
                self.videoReviewerForm.onSelectQuestion(self.data.questions[index].id, index);
            }
        };
    }
})();
